export default "__VITE_ASSET__1bce22e3__"